import { useTranslation } from 'react-i18next';
import { useWebinarLng } from '@/contexts/WebinarLanguageContext';

export function useWebinarT(ns: string = 'webinars') {
  const lng = useWebinarLng();
  return useTranslation(ns, { lng });
}
